export default __webpack_public_path__ + "static/media/picto-avaliacao_imoveis.db41bba7.svg";